import { GoogleGenerativeAI } from "@google/generative-ai";

// Usa tu clave real 

const apiKey = process.env.REACT_APP_API_GEMINI;
const genAI = new GoogleGenerativeAI(apiKey);

export async function analizarMensaje(mensaje) {

    try {
        // Usa un modelo válido 
        const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

        // Lista de reportes y sus equivalencias 
        const listaReportes = `
        - Reporte auxiliar de cuentas -> auxiliar_cuentas
        - Reporte de balanza general -> balance_general
        - Reporte de balanza -> balanza
        - Reporte diario -> diario
        - Reporte de estado de resultados -> estado_resultados
        - Reporte de libro mayor -> mayor
        - Reporte de operaciones diversas -> operacion_diversa
        - Reporte de póliza -> poliza
        - Reporte de recepción de pagos -> recepcion_pagos
        - Reporte de SAT -> sat
        `;

        // Prompt optimizado para la detección de reportes y archivos  
        const prompt = `
        Eres un asistente de IA que analiza mensajes y determina su intención.
        Si el usuario solicita un reporte, devuelve únicamente el identificador correspondiente según la lista.
        Si solicita generar un archivo PDF o Excel, devuelve "pdf" o "excel".
        Si solicita ma de un tipo de reportes en un mismo mensaje devuelve "1"
        Si en el mensaje manda el tipo de reporte y los datos con los que quiere generarlo devuelve un 2 y el identificador correspondiente según la lista, estos separados por una ",". Ejemplo 2,identificador
        Si no encaja en ninguna categoría, devuelve "ninguno".

        Lista de reportes:
        ${listaReportes}

        Mensaje del usuario:
        ${mensaje}
        `;

        // Genera contenido con el modelo  
        const result = await model.generateContent(prompt);

        // Verifica la estructura de la respuesta  
        //console.log("Respuesta completa de la API:", result);

        // Obtiene el contenido generado  
        if (result.response && result.response.candidates && result.response.candidates.length > 0) {
            const content = result.response.candidates[0].content;

            // Verifica si content tiene la estructura esperada  
            //console.log("Contenido generado:", content);

            // Si content es un objeto con partes, accede a la primera parte  
            const texto = content.parts ? content.parts[0].text : content;

            // Asegura que texto es una cadena antes de aplicar limpieza  
            return typeof texto === "string" ? texto.toLowerCase().replace(/\W/g, '') : "desconocido";
        } else {
            throw new Error("La respuesta de la API no contiene candidatos válidos.");
        }
    } catch (error) {
        console.error("Error al procesar el mensaje:", error);
        return "error";
    }
}

export async function buscarTipo(mensaje) {
    try {
        // Usa un modelo válido 
        const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

        // Lista de reportes y sus equivalencias 
        const listaTipos = `
        1. auxiliar_cuentas
        2. balance_general
        3. balanza
        4. diario
        5. estado_resultados
        6. mayor
        7. operacion_diversa
        8. poliza
        9. recepcion_pagos
        10. sat
        `;

        // Prompt optimizado para la detección de reportes y archivos  
        const prompt = `
        Eres un asistente de IA que analiza mensajes y busca en una lista.
        El usuario mandara un mensaje y tendras que buscar en la lista si existe, si si existe devolveras 1, si no existe devolveras 0".

        Lista de reportes:
        ${listaTipos}

        Mensaje del usuario:
        ${mensaje}
        `;

        // Genera contenido con el modelo  
        const result = await model.generateContent(prompt);

        // Verifica la estructura de la respuesta  
        //console.log("Respuesta completa de la API:", result);

        // Obtiene el contenido generado  
        if (result.response && result.response.candidates && result.response.candidates.length > 0) {
            const content = result.response.candidates[0].content;

            // Verifica si content tiene la estructura esperada  
            //console.log("Contenido generado:", content);

            // Si content es un objeto con partes, accede a la primera parte  
            const texto = content.parts ? content.parts[0].text : content;

            // Asegura que texto es una cadena antes de aplicar limpieza  
            return typeof texto === "string" ? texto.toLowerCase().replace(/\W/g, '') : "desconocido";
        } else {
            throw new Error("La respuesta de la API no contiene candidatos válidos.");
        }
    } catch (error) {
        console.error("Error al procesar el mensaje:", error);
        return "error";
    }
}
